import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ ...props }, ref) => {
    const textareaStyle = twMerge(
        "h-[200px] w-full resize-none border border-[#ddd] rounded-[12px] focus:border-primary p-[12px] text-[16px] placeholder:text-[#9F9FA5]",
        props.className,
    );
    return <textarea className={textareaStyle} {...props} ref={ref} />;
});

Textarea.displayName = "Textarea";
export default Textarea;
